import ObjectSelectionStepShared from "../common/components/ObjectSelectionStep/ObjectSelectionStepShared";
import { useObjectFirstEntry } from "../common/hooks/useObjectFirstEntry";
import { useFetchApartments } from "../../../redux/flows/fetchApartmentsFlow";

const CATEGORY_NOTICE_KEYS = {
  showAll: "book_location.category_notice.apartment.show_all",
  unknown: "book_location.category_notice.apartment.unknown",
};

/**
 * Room-rental object selection — the shared step, configured (ADR-0026,
 * phase 1 step 5).
 *
 * `reselectLocationOnPick` is what this flow did and the venue flow did not:
 * when the customer searched across "all districts" and then picks a room from
 * a different one, `selectedLocation` is re-pointed at that room's location.
 * Carried across unchanged rather than decided — see the prop's documentation
 * and #2764 E14.
 */
function ApartmentSelectionStep() {
  const searchAgain = useFetchApartments();
  // #3035: object-first narrows the dated result to the room already picked.
  const { pickedObjectId, pickedRoom } = useObjectFirstEntry("apartment");
  const capacity = Number(pickedRoom?.accomodationdetail?.guests);
  return (
    <ObjectSelectionStepShared
      errorMessageKey="book_location.error.fetch_apartments"
      reselectLocationOnPick
      categoryNoticeKeys={CATEGORY_NOTICE_KEYS}
      searchAgain={searchAgain}
      onlyObjectId={pickedObjectId}
      onlyObjectCapacity={Number.isInteger(capacity) && capacity > 0 ? capacity : null}
    />
  );
}

export default ApartmentSelectionStep;
